import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { ExternalLink } from 'lucide-react';

const projects = [
  {
    title: 'Residential Roof',
    category: 'Roof Painting',
    image: '/images/projects/project-1.jpg',
    altText: 'Residential roof painting project Sydney - Professional roof restoration',
  },
  {
    title: 'Modern Home',
    category: 'Exterior Painting',
    image: '/images/projects/project-2.jpg',
    altText: 'Modern home exterior painting Sydney - House painting services',
  },
  {
    title: 'Commercial Building',
    category: 'Commercial Painting',
    image: '/images/projects/project-3.jpg',
    altText: 'Commercial building painting Sydney - Professional painters',
  },
  {
    title: 'Heritage Home',
    category: 'Full Restoration',
    image: '/images/projects/project-4.jpg',
    altText: 'Heritage home restoration Sydney - Full house painting services',
  },
  {
    title: 'Roof Restoration',
    category: 'Roof Painting',
    image: '/images/projects/project-5.jpg',
    altText: 'Roof restoration project Sydney - Sydney Roof Painters',
  },
  {
    title: 'Exterior Makeover',
    category: 'Exterior Painting',
    image: '/images/projects/project-6.jpg',
    altText: 'Exterior makeover Sydney - Professional house painters',
  },
  {
    title: 'Interior Design',
    category: 'Interior Painting',
    image: '/images/projects/project-7.jpg',
    altText: 'Interior painting design Sydney - Quality workmanship',
  },
  {
    title: 'Complete Renovation',
    category: 'Full Restoration',
    image: '/images/projects/project-8.jpg',
    altText: 'Complete home renovation painting Sydney - Sydney Roof Painters',
  },
];

const Projects = () => {
  const { theme } = useTheme();

  return (
    <section 
      id="projects" 
      className={`${theme.layout.sectionSpacing} ${theme.colors.background}`}
      data-testid="projects-section"
    >
      <div className={theme.layout.container}>
        {/* Header */}
        <div className="text-center mb-16">
          <span className={`${theme.typography.bodyFont} text-[#ff5218] uppercase tracking-widest text-sm font-semibold`}>
            Portfolio
          </span>
          <h2 className={`
            ${theme.typography.headingFont} ${theme.typography.headingWeight}
            ${theme.colors.textPrimary} text-3xl md:text-4xl lg:text-5xl mt-4
            ${theme.typography.headingTracking} uppercase
          `}>
            Some Of Our Previous Projects
          </h2>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div 
              key={project.title}
              className="group relative overflow-hidden img-zoom border-2 border-slate-700 hover:border-[#ff5218]"
              data-testid={`project-${index}`}
            >
              <div className="aspect-[4/3]">
                <img 
                  src={project.image}
                  alt={project.altText}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>

              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-t from-slate-900 via-slate-900/80 to-transparent">
                <span className="text-xs uppercase tracking-wider mb-2 text-[#ff5218]">
                  {project.category}
                </span>
                <div className="flex items-center justify-between">
                  <h3 className={`${theme.typography.headingFont} text-white text-xl font-semibold uppercase`}>
                    {project.title}
                  </h3>
                  <div className="w-10 h-10 flex items-center justify-center bg-[#ff5218] text-white">
                    <ExternalLink className="w-5 h-5" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews */}
        <div className="mt-16 text-center">
          <a 
            href="https://www.google.com/search?q=asap+sydney+painters"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <img 
              src="/images/site/google-rating.png"
              alt="Sydney Roof Painters Google Reviews - 5 Star Rating"
              className="h-16 mx-auto hover:scale-105 transition-transform"
              loading="lazy"
              width="200"
              height="64"
            />
            <span className="block mt-2 text-[#ff5218] font-semibold">
              Click to see the reviews
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
